class RecentlyViewedProducts {
  constructor() {
    this.storageKey = 'recentlyViewedProducts';
    this.maxProducts = 5;
    this.initialize();
  }

  initialize() {
    this.addCurrentProduct();
    this.displayRecentlyViewed();
    this.setupEventListeners();
  }
  addCurrentProduct() {
    if (!this.isProductPage()) return;

    let productData = null;
    if (window.Shopify && window.Shopify.product) {
      productData = this.getProductFromShopify();
    }
    if (!productData) {
      productData = this.getProductFromMetaTags();
    }
    if (!productData) {
      productData = this.getProductFromDataAttributes();
    }
    if (!productData) {
      productData = this.getProductFromDOM();
    }

    if (productData && productData.handle) {
      this.addProduct(productData);
    }
  }

  isProductPage() {
    return window.location.pathname.includes('/products/');
  }

  getProductFromShopify() {
    if (typeof Product !== 'undefined' && Product) {
      return {
        handle: Product.handle,
        title: Product.title,
        image: this.getProductImageFromShopify(),
        url: window.location.pathname,
        price: Product.price ? (Product.price / 100).toFixed(2) : '',
        timestamp: Date.now()
      };
    }
    return null;
  }
  getProductImageFromShopify() {
    if (window.Product && Product.featured_image) {
      return Product.featured_image;
    }
    
    if (window.productImage && productImage.src) {
      return productImage.src;
    }
    const featuredImage = document.querySelector('.product-featured-image img, .product__media img, .product-image img');
    if (featuredImage && featuredImage.src) {
      return this.resizeImageUrl(featuredImage.src, 100);
    }
    
    return '';
  }
  getProductFromMetaTags() {
    const productHandle = document.querySelector('meta[property="og:url"], meta[name="product-handle"]');
    if (!productHandle) return null;

    let handle = '';
    const ogUrl = document.querySelector('meta[property="og:url"]')?.content;
    if (ogUrl && ogUrl.includes('/products/')) {
      handle = ogUrl.split('/products/')[1]?.split('?')[0] || '';
    }

    const title = document.querySelector('meta[property="og:title"], meta[name="product-title"]')?.content || document.title;
    const image = document.querySelector('meta[property="og:image"], meta[name="product-image"]')?.content || '';
    const price = document.querySelector('meta[property="product:price:amount"], meta[name="product-price"]')?.content || '';

    if (!handle) return null;

    return {
      handle: handle,
      title: title,
      image: this.resizeImageUrl(image, 100),
      url: window.location.pathname,
      price: price,
      timestamp: Date.now()
    };
  }

  getProductFromDataAttributes() {
    const productHandle = document.querySelector('[data-product-handle]');
    if (!productHandle) return null;

    const handle = productHandle.dataset.productHandle;
    const title = document.querySelector('[data-product-title]')?.dataset.productTitle || document.title;
    const image = document.querySelector('[data-product-image]')?.dataset.productImage || 
                  document.querySelector('[data-product-featured-image]')?.dataset.productFeaturedImage || '';
    const price = document.querySelector('[data-product-price]')?.dataset.productPrice || 
                  document.querySelector('[data-price]')?.dataset.price || '';

    return {
      handle: handle,
      title: title,
      image: this.resizeImageUrl(image, 100),
      url: window.location.pathname,
      price: price,
      timestamp: Date.now()
    };
  }

  getProductFromDOM() {
    const handleMatch = window.location.pathname.match(/\/products\/([^\/?]+)/);
    if (!handleMatch) return null;

    const handle = handleMatch[1];
    
    // Get title
    let title = '';
    const titleEl = document.querySelector('.product-title, .product__title, h1.product-title, h1[itemprop="name"]');
    if (titleEl) {
      title = titleEl.textContent.trim();
    } else {
      title = document.title.replace('| Shopify', '').trim();
    }

    // Get image
    let image = '';
    const imageSelectors = [
      '.product-featured-image img',
      '.product__media img',
      '.product-image img',
      '.product-single__photo img',
      '[data-product-gallery] img',
      '.product-media img'
    ];
    
    for (const selector of imageSelectors) {
      const imgEl = document.querySelector(selector);
      if (imgEl && imgEl.src) {
        image = this.resizeImageUrl(imgEl.src, 100);
        break;
      }
    }

    // Get price
    let price = '';
    const priceSelectors = [
      '.product-price',
      '.price',
      '.product__price',
      '[data-price]',
      '.price-item'
    ];
    
    for (const selector of priceSelectors) {
      const priceEl = document.querySelector(selector);
      if (priceEl) {
        price = priceEl.textContent.trim();
        break;
      }
    }

    return {
      handle: handle,
      title: title,
      image: image,
      url: window.location.pathname,
      price: price,
      timestamp: Date.now() 
    };
  }
  resizeImageUrl(url, size) {
    if (!url || !url.includes('cdn.shopify.com')) return url;
    try {
      const cleanedUrl = url.replace(/_\d+x\d+(?=\.\w+)/, '');
      const extensionMatch = cleanedUrl.match(/\.(jpg|jpeg|png|gif|webp)/i);
      
      if (extensionMatch) {
        const extension = extensionMatch[0];
        const baseUrl = cleanedUrl.replace(extension, '');
        return `${baseUrl}_${size}x${size}_cropped${extension}`;
      }
    } catch (e) {
      console.warn('Could not resize image URL:', e);
    }
    
    return url;
  }

  addProduct(productData) {
    let recentlyViewed = this.getProducts();
    recentlyViewed = recentlyViewed.filter(item => item.handle !== productData.handle);
    recentlyViewed.unshift(productData);
    if (recentlyViewed.length > this.maxProducts) {
      recentlyViewed = recentlyViewed.slice(0, this.maxProducts);
    }  
    localStorage.setItem(this.storageKey, JSON.stringify(recentlyViewed));
  }

  getProducts() {
    try {
      const products = JSON.parse(localStorage.getItem(this.storageKey)) || [];
      return products.filter(p => p && p.handle && p.title && p.url && p.url !== '/');
    } catch (e) {
      console.error('Error reading recently viewed products:', e);
      return [];
    }
  }

  displayRecentlyViewed() {
    const container = document.getElementById('predictive-recently-viewed-list');
    if (!container) return;
    
    const recentlyViewed = this.getProducts();
    const parentContainer = container.closest('.predictive-recently-viewed');
    
    if (!parentContainer) return;
    
    if (recentlyViewed.length === 0) {
      parentContainer.style.display = 'none';
      return;
    }
    
    parentContainer.style.display = 'block';
    container.innerHTML = '';
    
    recentlyViewed.forEach((product, index) => {
      const productElement = this.createProductElement(product, index);
      container.appendChild(productElement);
    });
  }
  createProductElement(product, index) {
    const item = document.createElement('a');
    item.href = product.url;
    item.className = 'predictive-recent-item';
    item.setAttribute('data-product-handle', product.handle);
    let imageHtml = '';
    if (product.image && product.image.trim() !== '') {
      const safeImage = this.escapeHtml(product.image).replace(/"/g, '&quot;').replace(/'/g, '&#39;');
      const safeTitle = this.escapeHtml(product.title);
      
      imageHtml = `
        <div class="predictive-recent-item-image-wrapper">
          <img 
            src="${safeImage}" 
            alt="${safeTitle}" 
            loading="lazy" 
            width="50" 
            height="50"
            onload="this.classList.add('loaded')"
            onerror="this.style.display='none'; this.nextElementSibling.style.display='block';"
          >
          <div class="predictive-recent-item-placeholder" style="display:none"></div>
        </div>
      `;
    } else {
      return null;
    }
    
    item.innerHTML = `
      ${imageHtml}
      <div class="predictive-recent-item-info">
        <div class="predictive-recent-item-title">${this.escapeHtml(this.truncateText(product.title, 40))}</div>
        ${product.price ? `<div class="predictive-recent-item-price">${this.escapeHtml(product.price)}</div>` : ''}
      </div>
    `;
    
    return item;
  }
  async fetchProductImage(handle, element) {
    try {
      const response = await fetch(`/products/${handle}.json`);
      if (response.ok) {
        const productData = await response.json();
        const image = productData.product?.images?.[0]?.src;
        if (image) {
          let recentlyViewed = this.getProducts();
          const productIndex = recentlyViewed.findIndex(p => p.handle === handle);
          if (productIndex !== -1) {
            recentlyViewed[productIndex].image = this.resizeImageUrl(image, 100);
            recentlyViewed[productIndex].url = `/products/${handle}`; // Ensure correct URL
            localStorage.setItem(this.storageKey, JSON.stringify(recentlyViewed));
          }
          
          const imgElement = element.querySelector(`img[data-handle="${handle}"]`);
          if (imgElement) {
            imgElement.src = this.resizeImageUrl(image, 100);
            imgElement.alt = productData.product.title;
            imgElement.onload = () => {
              imgElement.classList.add('loaded');
              imgElement.previousElementSibling.style.display = 'none';
            };
          }
        }
      }
    } catch (error) {
      console.warn(`Could not fetch image for product ${handle}:`, error);
    }
  }

  truncateText(text, maxLength) {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  }

  escapeHtml(text) {
    if (!text) return '';
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  setupEventListeners() {
    document.addEventListener('focusin', (e) => {
      if (this.isSearchInput(e.target)) {
        setTimeout(() => this.displayRecentlyViewed(), 50);
      }
    });
    document.addEventListener('input', (e) => {
      if (this.isSearchInput(e.target)) {
        setTimeout(() => this.displayRecentlyViewed(), 50);
      }
    });

    document.addEventListener('shopify:section:load', () => {
      setTimeout(() => {
        this.addCurrentProduct();
        this.displayRecentlyViewed();
      }, 300);
    });
    window.addEventListener('popstate', () => {
      setTimeout(() => {
        this.addCurrentProduct();
        this.displayRecentlyViewed();
      }, 500);
    });

    setInterval(() => {
      if (document.hidden) return;
      this.displayRecentlyViewed();
    }, 30000); 
  }

  isSearchInput(element) {
    return element.matches('input[type="search"], .search-input, .predictive-search-input, [name="q"], [type="search"]');
  }
  addProductManually(handle, title, image, url, price) {
    const productData = {
      handle: handle,
      title: title,
      image: this.resizeImageUrl(image, 100),
      url: url || `/products/${handle}`,
      price: price,
      timestamp: Date.now()
    };
    
    this.addProduct(productData);
    this.displayRecentlyViewed();
  }

  clearRecentlyViewed() {
    localStorage.removeItem(this.storageKey);
    this.displayRecentlyViewed();
  }

  getCount() {
    return this.getProducts().length;
  }
  debug() {
    console.log('Recently Viewed Products:', this.getProducts());
    console.log('Storage Key:', this.storageKey);
    console.log('Max Products:', this.maxProducts);
  }
}
document.addEventListener('DOMContentLoaded', () => {
  try {
    window.recentlyViewedProducts = new RecentlyViewedProducts();
    console.log('Recently Viewed Products initialized');
  } catch (error) {
    console.error('Failed to initialize Recently Viewed Products:', error);
  }
});
if (typeof module !== 'undefined' && module.exports) {
  module.exports = RecentlyViewedProducts;
}
if (typeof Shopify !== 'undefined') {
  document.addEventListener('shopify:section:load', function() {
    if (window.recentlyViewedProducts) {
      window.recentlyViewedProducts.displayRecentlyViewed();
    }
  });
}
